


















































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { GuideCategoryDataModule } from '@/app/store/modules/guideCategory'
import { defaultImage } from '@/utils/default'
@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-image': ModalImage,
    'image-select': ImageSelect,
  },
})
export default class extends Vue {
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public dataTable
  @Prop({}) public fields
  @Prop({}) public selected
  @Prop({}) public imageDataCategory
  @Prop({}) public isLoading
  @Prop({}) public clearTableStatus

  @Watch('clearTableStatus')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$refs.selectableTable.clearSelected()
  }
  public get isFilledDataTable() {
    return (
      this.dataTable !== undefined && this.dataTable.pagination !== undefined
    )
  }
  // Row Selected
  public $refs!: {
    selectableTable: HTMLFormElement
  }
  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }
  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }

  // form edit
  public id: number = 0
  public name: string = ''
  public get validName(): boolean {
    return this.name.length >= 4 ? true : false
  }
  public status: boolean = true
  public carType: string = ''
  public imageCoverId: any = {
    id: null,
    link: defaultImage,
  }
  public imageThumbnailId: any = {
    id: null,
    link: defaultImage,
  }
  public imageLogoId: any = {
    id: null,
    link: defaultImage,
  }
  public changeImageCoverId(item) {
    this.imageCoverId.id = item.id
    this.imageCoverId.link = item.link
  }
  public changeImageThumbnailId(item) {
    this.imageThumbnailId.id = item.id
    this.imageThumbnailId.link = item.link
  }
  public changeImageLogoId(item) {
    this.imageLogoId.id = item.id
    this.imageLogoId.link = item.link
  }

  // options Form
  public optionsCarType = [
    { value: 'Passenger Car', text: 'Passenger Car' },
    { value: 'Light Commercial Vehicle', text: 'Light Commercial Vehicle' },
  ]
  public optionsStatus = [
    { value: true, text: 'Active' },
    { value: false, text: 'Inactive' },
  ]

  // Method Delete Data
  public modalDelete = {
    id: 'modal-delete',
    idCategory: 0,
    categoryName: '',
  }
  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.categoryName = item.name
      this.modalDelete.idCategory = item.id
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public deleteNotif() {
    const ids = [this.modalDelete.idCategory]
    GuideCategoryDataModule.deleteGuideCategory({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }

  // Method Edit Data
  public funcEdit(item, index, button) {
    //  console.log('item', item)
    if (this.$props.selected.length < 1) {
      this.id = item.id
      this.name = item.name
      this.status = item.isActive
      this.carType = item.tag
      this.imageCoverId = item.imageCover
      this.imageThumbnailId = item.imageThumbnail
      this.imageLogoId = item.imageLogo
      this.$root.$emit('bv::show::modal', 'edit-data', button)
    }
  }
  public funcEditData() {
    if (this.validName === false) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        name: this.name,
        isActive: this.status,
        imageCoverId: this.imageCoverId.image_id,
        imageThumbnailId: this.imageThumbnailId.image_id,
        imageLogoId: this.imageLogoId.image_id,
        tag: this.carType,
      }
      GuideCategoryDataModule.updateGuideCategory(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'edit-data')
    }
  }
  public resetEditModal() {
    this.id = 0
    this.name = ''
    this.status = true
    this.carType = ''
  }
}
